import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { authOperations } from '../redux/auth';

import PathNavLink from '../components/common/PathNavLink';

import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import DropdownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import AppsIcon from 'material-ui/svg-icons/navigation/apps';
import ChangelogIcon from 'material-ui/svg-icons/av/new-releases';
import SignoutIcon from 'material-ui/svg-icons/action/power-settings-new';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import FireIcon from 'material-ui/svg-icons/social/whatshot';
import MapIcon from 'material-ui/svg-icons/maps/map';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import AccessibilityIcon from 'material-ui/svg-icons/action/accessibility';
import { mapOperations } from '../redux/map';
import { homepage } from '../../package.json';
import theme from '../muiTheme';
import logo from '../images/irwin-logo-white.svg';
import { configOperations } from '../redux/config';

const styles = {
  headerStyle: {
    background: theme.palette.primary1Color,
    color: theme.palette.alternateTextColor
  },
  avatarStyle: {
    marginRight: '5px',
    border: '1px solid #fff'
  },
  logoStyle: {
    height: '32px'
  }
};

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userMenuOpen: false
    };
  }

  userMenuClick = event => {
    event.preventDefault();

    this.setState({
      userMenuOpen: true,
      anchorEl: event.currentTarget
    });
  };

  userMenuClose = () => {
    this.setState({
      userMenuOpen: false
    });
  };

  logoutSelected = () => {
    this.props.logout();
  };

  render() {
    let userAvatar;
    if (this.props.auth.user.thumbnailUrl) {
      userAvatar = (
        <Avatar
          src={this.props.auth.user.thumbnailUrl}
          style={styles.avatarStyle}
          size={30}
        />
      );
    } else {
      userAvatar = (
        <Avatar
          style={{ marginRight: '5px' }}
          color={theme.palette.accent1Color}
          backgroundColor={theme.palette.canvasColor}
          size={30}
        >
          {this.props.auth.user.fullName[0]}
        </Avatar>
      );
    }

    let userRole = 'User';
    if (this.props.auth.user.isAdmin) {
      userRole = 'Admin';
    }

    const userInfo = `
      Session Info: %0D%0A
      User: ${this.props.auth.user.username} %0D%0A
      Version: ${this.props.appConfig.version} %0D%0A
      Environment: ${this.props.appConfig.env} %0D%0A
      `;

    let next = false;
    if (this.props.appConfig.env.includes('next')) {
      next = true;
    }

    const q = window.location.search;

    const basename = process.env.NODE_ENV !== 'production' ? '' : `${homepage}`;

    const mapColumnNodeInRoute = [
      '/resources',
      '/dispatchmap',
      '/resource-history'
    ].includes(this.props.location.pathname);

    return (
      <div className="app-header" style={styles.headerStyle}>
        <div className="header-branding">
          <h1>
            <img src={logo} alt="irwin logo" style={styles.logoStyle} />
            <span>Observer</span>
          </h1>
        </div>
        <div className="header-links">
          <PathNavLink exact to={`/incidents${q}`}>
            Incidents
          </PathNavLink>

          <PathNavLink exact to={`/dispatches${q}`}>
            Current Dispatch
          </PathNavLink>
          {/* conditionally show the dashboards tab depending on if user is in PROD */}
          {this.props.appConfig.env === 'prod' ? (
            <PathNavLink exact to={`/dashboards${q}`}>
              Dashboards
            </PathNavLink>
          ) : null}
        </div>
        <div>
          {/* conditionally show the map column toggle button
          if the map column exists in this route */}
          {!mapColumnNodeInRoute && (
            <IconButton
              onClick={() => {
                this.props.setMapColumnVisible(
                  !this.props.map.mapColumnVisible
                );

                this.props.setMapPrefs(true);
              }}
              tooltip="Toggle map panel"
              tooltipPosition="bottom-left"
              style={{ marginRight: '10px' }}
            >
              <MapIcon
                color={
                  this.props.map.mapColumnVisible
                    ? '#fff'
                    : 'rgba(255, 255, 255, 0.7)'
                }
              />
            </IconButton>
          )}
        </div>
        <div>
          <IconButton
              onClick={() => {
              window.open('https://www.doi.gov/accessibility');
            }}
              tooltip="Accessibility"
              tooltipPosition="bottom-left"
              style={{ marginRight: '10px' }}
            >
            <AccessibilityIcon color={'#fff'}/>
            </IconButton>
        </div>
        {next ? (
          <div className="header-next">
            <FireIcon color="yellow" />
            {this.props.appConfig.env}
            <FireIcon color="yellow" />
          </div>
        ) : null}
        <div className="header-user">
          {userAvatar}
          <FlatButton
            onClick={this.userMenuClick}
            label={this.props.auth.user.fullName}
            labelPosition="before"
            labelStyle={{
              color: '#fff',
              paddingLeft: '10px',
              fontWeight: 400
            }}
            icon={<DropdownIcon color="#fff" style={{ marginRight: '5px' }} />}
          />
          <Popover
            open={this.state.userMenuOpen}
            anchorEl={this.state.anchorEl}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            targetOrigin={{ horizontal: 'right', vertical: 'top' }}
            onRequestClose={this.userMenuClose}
          >
            {/* eslint-disable */}
            <Menu>
              <MenuItem
                leftIcon={<AppsIcon />}
                primaryText="ArcGIS Online"
                containerElement={
                  <a target="_blank" href={this.props.appConfig.portalUrl} />
                }
              />
              <MenuItem
                leftIcon={<ChangelogIcon />}
                primaryText="Changelog"
                containerElement={
                  <a
                    target="_blank"
                    href={`${basename}${this.props.appConfig.changelog}`}
                  />
                }
              />
              <MenuItem
                leftIcon={<EmailIcon />}
                primaryText="Feedback"
                containerElement={
                  <a
                    href={
                      'mailto:' +
                      this.props.appConfig.feedback.to +
                      '?subject=' +
                      this.props.appConfig.feedback.subject +
                      '&body=' +
                      this.props.appConfig.feedback.body +
                      '%0D%0A%0D%0A%0D%0A' +
                      userInfo
                    }
                  />
                }
              />
              <MenuItem
                leftIcon={<SignoutIcon />}
                primaryText="Sign out"
                onClick={this.logoutSelected}
              />
              <Divider />
              <Subheader style={{ lineHeight: '30px' }}>
                <span>Observer Role: {userRole}</span>
              </Subheader>
              <Subheader style={{ lineHeight: '30px', padding: '0 16px' }}>
                <span>version {this.props.appConfig.version}</span>
                <span style={{ float: 'right' }}>
                  IRWIN {this.props.appConfig.env.toUpperCase()}
                </span>
              </Subheader>
            </Menu>
            {/* eslint-enable */}
          </Popover>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map,
  auth: state.auth,
  preferences: state.config.preferences,
  appConfig: state.config
});

const mapDispatchToProps = function(dispatch) {
  return bindActionCreators(
    {
      ...mapOperations,
      ...authOperations,
      ...configOperations
    },
    dispatch
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Header)
);



// WEBPACK FOOTER //
// ./src/components/Header.js